import { render } from "./PermitsMenuFavoritesAndPending.vue?vue&type=template&id=a565ff66"
import script from "./PermitsMenuFavoritesAndPending.vue?vue&type=script&lang=js"
export * from "./PermitsMenuFavoritesAndPending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__